import { React, useEffect, useState } from 'react';

export default function Embed ({ embedded, setEmbedded, insights, embeddedPanelHeight }) {
	useEffect(() => {
		setEmbedded('true');
	});
	// Set the embedded class
	document.body.classList.add('embedded');
	// Send an initial message with the status.
	if (insights.status !== 'Closed') { // Temp
		// window.parent.postMessage('status:' + insights.status, '*'); // Temp
	} // Temp

	// Get the BG colour param
	const urlParams = new URLSearchParams(window.location.search);
	let bgColour = urlParams.get('bg');
	const cookiesAccept = urlParams.get('cookies');
	let customBG = false;
	// Validate the BG
	if (bgColour) {
		if ((bgColour.length === 6)) {
			for (let i = 1; i < bgColour.length; i++) {
				if (
					!(
						(bgColour[i].charCodeAt(0) <= '0'.charCodeAt(0) && bgColour[i].charCodeAt(0) <= 9) ||
						(bgColour[i].charCodeAt(0) >= 'a'.charCodeAt(0) && bgColour[i].charCodeAt(0) <= 'f'.charCodeAt(0)) ||
						(bgColour[i].charCodeAt(0) >= 'A'.charCodeAt(0) || bgColour[i].charCodeAt(0) <= 'F'.charCodeAt(0))
					)
				) {
					return false;
				} else {
					customBG = true;
				}
			}
		}
	} else {
		customBG = true;
		bgColour = 'transparent';
	}
	// Set the BG if valid
	if (customBG) {
		document.documentElement.style.setProperty('--c-bg-body',   '#' + bgColour);
		document.documentElement.style.setProperty('--c-bg-survey', '#' + bgColour);
	}
	// Set BG if it's transparent
	if (bgColour === 'transparent') {
		document.documentElement.style.setProperty('--c-bg-body',   'transparent');
		document.documentElement.style.setProperty('--c-bg-survey', 'transparent');
	}

	// Auto accept cookies if accepted on parent site
	if (cookiesAccept === 'true') {
		localStorage.setItem('consent', 'accepted');
	}

	// Handle Resize
	// Message is sent from the iframe
	window.addEventListener('message', postMessageEvent => {
		if (postMessageEvent.data === 'resize:true') {
			embeddedPanelHeight('on parent resize');
		}
	});

	return (
		<></>
	);
}
